// Imports
import $ from 'jquery';

initSocialLinks();

function initSocialLinks() {
    const articleShareClass = '.article-share';
    const weChatURL = '.wechat-tooltip';
    const articleURL = window.location.href;

    // early return if no component found
    if (!$(articleShareClass).length) { return; }

    if ($(weChatURL).length) {
        $(weChatURL).attr('title', `Copy the link <input type="text" id="share-url" value="${articleURL}"></input> then weChat logo to open the App.`);
    }

    $(articleShareClass).find('a').click(function (e) {
        e.preventDefault();
        window.open(
            this.href, 'targetWindow',
            'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=800, height=400'
        );
    });
}
